import { User } from '@src/entities/User/ui/components/User';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

/**
 * CreateMenu
 *
 * Displays a dropdown menu with options to create an action path with entrance criteria or manually.
 *
 * @returns {Element}
 * @constructor
 */
export function CreateMenu() {
  const router = useRouter();

  return (
    <ErrorHandler location="src/features/ActionPaths/Creation/components/buttons/CreateMenu/CreateMenu.jsx">
      <User.Capability attributes={['create']} resource="ActionPaths">
        <DropdownMenu
          after={<IconSymbol icon="keyboard_arrow_down" />}
          className="no-padding no-margin"
          data-testid="create-button"
          label="Create"
          menuItems={[
            {
              onClick: () => {
                router?.navigate(`/action-paths/0/create/automatic/draft/step/1`);
              },
              title: 'Create with Entrance Criteria',
            },
            {
              onClick: () => {
                router?.navigate(`/action-paths/0/create/manual/draft/step/1`);
              },
              title: 'Create Manually',
            },
          ]}
          outline
        />
      </User.Capability>
    </ErrorHandler>
  );
}
